// filepath: frontend/src/pages/LoginRequiredPage.tsx
import React from 'react';
import { Link } from 'react-router-dom';

const LoginRequiredPage: React.FC = () => {
    return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
            <h1>Login Required</h1>
            <p style={{ color: 'red' }}>You must be logged in to access this page.</p>
            <Link to="/">Go to Home</Link>
        </div>
    );
};

export default LoginRequiredPage;